import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Button } from '@resy/ui-kitchen';
import Chevron from '../../../../images/amexrga/chevron-left.svg';
import Minus from '../../../../../../../ui-kitchen/src/svg/icons/ic_remove_20x20.svg';
import Plus from '../../../../../../../ui-kitchen/src/svg/icons/ic_add_20x20.svg';
import { sanitizeString } from '../../../../../../../ui-kitchen/src/utils/sanitizeString';
import { handleMktAnalytics } from '../../AmexUtils';
import { CTA_EVENT_NAME } from '../../constants';
import './Accordion.scss';

const Accordion = (
  {

    question,
    answer,
    id,
    hash,
    eventAnalytics,
    iconPlusMinus,
    iconPosition,
    printContent,
  }
) => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const target = `questionTitle${id}`;
    const currentHash = hash.replace('#', '');
    const hasHashMatch = hash && currentHash === target;
    setIsActive(hasHashMatch);
  }, [hash]);

  const sanitizedAnswer = sanitizeString(answer);

  const Icon = iconPlusMinus ? (isActive ? Minus : Plus) : Chevron; // eslint-disable-line no-nested-ternary

  const renderIcon = (
    <span className="Accordion__iconwrapper">
      <Icon className={cx('Accordion__icon', [iconPlusMinus ? 'icon-plus-minus' : 'icon-chevron'])} aria-hidden="true" />
    </span>
  );

  const renderCopy = (copy) => (printContent
    ? printContent(copy, [copy], true) : copy);

  return (
    <li
      className="Accordion"
    >
      <h3
        className={`Accordion__title ${isActive ? 'active' : ''}`}
      >
        <Button
          variant="no-style"
          type="button"
          id={`questionTitle${id}`}
          aria-controls={`questionAnswer${id}`}
          className={cx('Accordion__button', {
            active: isActive,
            'icon-right': iconPosition === 'right',
            'icon-plus-minus': iconPlusMinus,
          })}
          aria-expanded={isActive}
          onClick={() => {
            setIsActive((prev) => !prev);
            const extraParam = {
              action_name: 'FAQ - Click',
              ...(question && { item_name: question }),
            };
            handleMktAnalytics(eventAnalytics, CTA_EVENT_NAME, extraParam);
          }}
        >
          {renderIcon}
          {renderCopy(question)}
        </Button>
      </h3>
      <div
        role="region"
        aria-labelledby={`questionTitle${id}`}
        id={`questionAnswer${id}`}
        className={`Accordion__content ${isActive ? 'active' : ''}`}
        aria-hidden={!isActive}
      >
        <div className="Accordion__inner">
          <div
            className="Accordion__text"
            dangerouslySetInnerHTML={{
              __html: renderCopy(sanitizedAnswer),
            }}
          />
        </div>
      </div>
    </li>
  );
};

Accordion.propTypes = {
  question: PropTypes.string.isRequired,
  answer: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  hash: PropTypes.string,
  eventAnalytics: PropTypes.func,
  printContent: PropTypes.func,
  iconPlusMinus: PropTypes.bool,
  iconPosition: PropTypes.string,

};

Accordion.defaultProps = {
  hash: '',
  eventAnalytics: null,
  iconPlusMinus: false,
  iconPosition: 'left',
  printContent: null,
};

export default Accordion;
